export { RecentSearches } from "./RecentSearches";